import { Icon, Text } from '@hotjar/hotsauce';
import styled from '@emotion/styled';
import type { IconSetDefinitions } from '@hotjar/hotsauce/build/components/Icon/icons';
import type { AdvancedOptionProps } from './AdvancedOption';
import { AdvancedOption } from './AdvancedOption';

export type IconOptionProps = Omit<AdvancedOptionProps, 'children'> & {
  icon?: keyof IconSetDefinitions;
  children: string;
};

const StyledText = styled(Text)`
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const IconOption = ({
  id,
  value,
  children,
  icon,
  badge,
  planBadge,
}: IconOptionProps): JSX.Element => {
  return (
    <AdvancedOption id={id} value={value} badge={badge} planBadge={planBadge}>
      <>
        {icon !== undefined && <Icon icon={icon} />}
        <StyledText title={children}>{children}</StyledText>
      </>
    </AdvancedOption>
  );
};
